import style from "css/hotdesking.module.css";
import React from "react";
import { Tabs } from "antd-mobile";
import { useTranslation } from "react-i18next";

function SearchMenu({ view, onChange }) {
  const { t } = useTranslation();
  const options = [
    { key: "today", title: t("HOTDESKING.MENU.RESERVE") },
    { key: "employee", title: t("HOTDESKING.MENU.TEAM.TITLE") },
  ];
  return (
    <Tabs
      className={style.search_menu}
      activeLineMode="full"
      activeKey={view}
      onChange={onChange}
      stretch
    >
      {options.map((item) => (
        <Item key={item.key} title={item.title} />
      ))}
    </Tabs>
  );
}

function Item({ title }) {
  return <Tabs.Tab>{title}</Tabs.Tab>;
}

export default SearchMenu;
